import formatGroupedValues from "../utils/formatGroupedValues";
import capitalizeFilterLabel from "../utils/capitalizeFilterLabel";

export const FILE_SORT_OPTIONS = [
  { value: "file_name", label: "Name" },
  { value: "state", label: "State" },
  { value: "type_name", label: "Type" },
  { value: "expiry_date", label: "Expiry" },
];

export const FILE_STATE_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "Pending Review", label: "Pending Review" },
];

export function buildPersonnelFilesFilterChips(filterData, { fileTypes = [] } = {}) {
  const chips = [];
  const typeIds = filterData?.type_ids || [];
  if (typeIds.length > 0) {
    const labelFor = (id) => {
      const t = fileTypes.find((ft) => String(ft.type_id) === String(id));
      return t?.name || id;
    };
    chips.push({
      id: "types",
      key: "type_ids",
      fieldId: "file-types",
      label: `Type: ${formatGroupedValues(typeIds, labelFor, 3)}`,
    });
  }
  const states = filterData?.states || [];
  if (states.length > 0) {
    chips.push({
      id: "states",
      key: "states",
      fieldId: "file-states",
      label: `Status: ${formatGroupedValues(states, capitalizeFilterLabel, 3)}`,
    });
  }
  if (filterData?.showDeleted) {
    chips.push({
      id: "deleted",
      key: "showDeleted",
      fieldId: "file-show-deleted",
      label: "Show Deleted",
    });
  }
  return chips;
}

export function countPersonnelFilesActiveFilters(filterData) {
  let n = 0;
  if ((filterData?.type_ids || []).length > 0) n += 1;
  if ((filterData?.states || []).length > 0) n += 1;
  if (filterData?.showDeleted) n += 1;
  return n;
}
